/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronDown: {
  name: 'chevron-down';
  data: string;
} = {
  name: 'chevron-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.646 5.646a.5.5 0 0 1 .708 0L8 9.293l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708Z" fill="currentColor"/></svg>`,
};
